import type { LucideIcon } from 'lucide-react';
import { Link } from 'react-router';

type Props = {
  icon: LucideIcon;
  to?: string;
  title: string;
  summary: string;
};

export default function CheckupItem({ icon, to, title, summary }: Props) {
  const Icon = icon;

  const Component = to ? Link : 'div';

  return (
    <Component
      to={to ?? ''}
      className="shadow-card flex gap-2 rounded-lg border p-2"
    >
      <div className="bg-primary-100 dark:bg-primary-900 flex size-9 items-center justify-center rounded-md">
        <Icon className="text-primary-500 size-4" />
      </div>

      <div className="flex flex-col">
        <span className="text-sm">{title}</span>

        <span className="text-muted-foreground text-xs">{summary}</span>
      </div>
    </Component>
  );
}
